import util from '@bmp-vue/core/api/util'

const controller = 'TipoDominio'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']))
